export default __webpack_public_path__ + "static/media/weprofile-400.967c68ff.png";